import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useState } from "react";
import { SelectInput, required } from "react-admin";
import { useController } from "react-hook-form";
import { FormControlLabel, FormGroup, FormHelperText, Switch } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Dialog } from "@sequentech/ui-essentials";
import { EMobileCandidateLists } from "@sequentech/ui-core";
import { SLATES_ENABLED_FIELD, SLATES_MOBILE_CANDIDATE_LISTS_FIELD } from "@/utils/slates";
export var SlatesBallotDesignInput = function (_a) {
    var slatesCount = _a.slatesCount, disabled = _a.disabled;
    var t = useTranslation().t;
    var field = useController({ name: SLATES_ENABLED_FIELD }).field;
    var _b = useState(false), isConfirmOpen = _b[0], setIsConfirmOpen = _b[1];
    var isEnabled = field.value === true;
    var onToggle = function (event) {
        if (!event.target.checked && slatesCount > 0) {
            setIsConfirmOpen(true);
            return;
        }
        field.onChange(event.target.checked);
    };
    return (_jsxs(_Fragment, { children: [_jsxs(FormGroup, { sx: { marginBottom: "1rem" }, children: [_jsx(FormControlLabel, { control: _jsx(Switch, { name: field.name, checked: isEnabled, onChange: onToggle, onBlur: field.onBlur, disabled: disabled, color: "primary" }), label: t("electionScreen.slates.enable.label") }), _jsx(FormHelperText, { sx: { marginTop: 0 }, children: t("electionScreen.slates.enable.helper") })] }), isEnabled && (_jsx(SelectInput, { source: SLATES_MOBILE_CANDIDATE_LISTS_FIELD, label: String(t("electionScreen.slates.mobileCandidateLists.label")), helperText: String(t("electionScreen.slates.mobileCandidateLists.helper")), choices: Object.values(EMobileCandidateLists).map(function (option) { return ({
                    id: option,
                    name: t("electionScreen.slates.mobileCandidateLists.options.".concat(option)),
                }); }), defaultValue: EMobileCandidateLists.COLLAPSED, validate: required(), disabled: disabled })), _jsx(Dialog, { variant: "warning", open: isConfirmOpen, ok: String(t("electionScreen.slates.disable.confirm")), cancel: String(t("common.label.cancel")), title: String(t("common.label.warning")), handleClose: function (result) {
                    if (result) {
                        field.onChange(false);
                    }
                    setIsConfirmOpen(false);
                }, children: t("electionScreen.slates.disable.message", { count: slatesCount }) })] }));
};
